import DialogPage from "../DialogPage";
import {useContext} from "react";
import {OrderContext} from "../../../contexts/OrderContext";
import AppConfigContext from "../../../contexts/AppConfigContext";
import {Colors} from "../colors";
import {ColumnSpace} from "../components/_CommonComponents";
import Text from "../components/Text";
import Button from "../components/Button";
import IPGCompletionScreenFunction from "../../../components/screen-functions-components/IPGCompletionScreenFunction";
import IPGCompletionComponents from "../../../components/functional-components/IPGCompletionComponents";

export default function IPGCompletion(props: any) {

    const orderContext = useContext(OrderContext);
    const colors = Colors.instanceNoServerColor(useContext(AppConfigContext).theme, useContext(AppConfigContext).color);

    return <DialogPage {...props} header={"تکمیل فرآیند پرداخت"}>

        <IPGCompletionScreenFunction>

            <IPGCompletionComponents orderContext={orderContext}>

                <Text role={"desc-text"} style={{textAlign: "center"}} color={colors.get("green") as string} size={12}
                      weight={600}/>
                <ColumnSpace/>

                <Text role="summary-text" color={colors.get("highConText") as string} size={14}/>
                <ColumnSpace/>

                <Text role="price-text" style={{textAlign: "center"}} size={20}/>
                <ColumnSpace/>

                <Button role="button-go" color={colors.get("green") as string}/>
                <ColumnSpace/>

                <Button role="button-cancel" style={{width: "80%", alignSelf: "center"}}
                        color={colors.get("red") as string}/>

            </IPGCompletionComponents>

        </IPGCompletionScreenFunction>

    </DialogPage>
}
